import type { Product } from '@scayle/storefront-nuxt'
import { unique } from 'radash'

export function usePromotionGifts(product: Product) {
  const basketData = useBasket()
  const productPromotions = useProductPromotions(product)

  const { buyXGetYPromotion } = productPromotions

  const variantIds = computed(() => getVariantIds(buyXGetYPromotion.value))

  const isGiftAlreadyAdded = computed(() => {
    return (basketData.data.value?.items ?? []).some((item) => {
      const isGift = variantIds.value?.includes(item.variant.id)
      return (
        isGift &&
        item.promotionId &&
        isBuyXGetYType(item.promotion) &&
        item.promotionId === buyXGetYPromotion.value?.id
      )
    })
  })

  const promotionStyle = computed(() =>
    getPromotionStyle(buyXGetYPromotion.value?.customData),
  )

  const hasMultipleFreeGifts = computed(() => variantIds.value.length > 1)

  const { data: variants } = useVariant({
    params: { ids: variantIds.value },
    key: `promotion-variants-${buyXGetYPromotion.value?.id}`,
  })

  const { data: productsData } = useProductsByIds({
    params: {
      ids: variants.value?.map(({ productId }) => productId) ?? [],
    },
    key: `promotion-products-${buyXGetYPromotion.value?.id}`,
  })

  const products = computed(() => {
    const items = unique(productsData.value || [], ({ id }) => id)
    return items.map((item) => {
      const filteredVariants = item.variants?.filter(({ id }) => {
        return variantIds.value.includes(id)
      })
      return { ...item, variants: filteredVariants }
    })
  })

  return extendPromise(
    Promise.all([basketData, productPromotions]).then(() => ({})),
    {
      variantIds,
      products,
      promotionStyle,
      hasMultipleFreeGifts,
      isGiftAlreadyAdded,
    },
  )
}
